/**
 * Gift Personalization Script
 * Compatible with Prestige Theme & Shopify OS 2.0
 */
window.gpOpenModal = function() {
  const backdrop = document.getElementById('gp-modal-backdrop');
  if (backdrop) {
    backdrop.classList.add('active');
    backdrop.style.display = 'flex';
    setTimeout(() => {
      backdrop.style.opacity = '1';
      backdrop.style.pointerEvents = 'auto';
    }, 10);
  }
  document.body.classList.add('gp-modal-open');
  document.documentElement.classList.add('gp-modal-open');

  // مزامنة المقاس أو الخيار المختار حالياً من صفحة المنتج فوراً
  try {
    const themeVariantInput = document.querySelector('product-form form input[name="id"], .product-info__block-item[data-block-type="buy-buttons"] input[name="id"]');
    let curId = themeVariantInput ? themeVariantInput.value : null;
    if (!curId) {
      const urlParams = new URLSearchParams(window.location.search);
      curId = urlParams.get('variant');
    }
    if (curId && window.gpSyncVariant) {
      window.gpSyncVariant(curId);
    }
  } catch (e) {
    console.warn('[GiftPersonalization] Variant sync on open error:', e);
  }

  if (window.gpRecalculate) window.gpRecalculate();
  if (window.gpResetWizard) window.gpResetWizard();
};

window.gpCloseModal = function() {
  const backdrop = document.getElementById('gp-modal-backdrop');
  if (backdrop) {
    backdrop.style.opacity = '0';
    backdrop.style.pointerEvents = 'none';
    backdrop.classList.remove('active');
    setTimeout(() => {
      backdrop.style.display = 'none';
    }, 300);
  }
  document.body.classList.remove('gp-modal-open');
  document.documentElement.classList.remove('gp-modal-open');
  const err = document.getElementById('gp-error-notice');
  if (err) err.style.display = 'none';
};

(function() {
  function initPersonalization() {
    const section = document.querySelector('[id^="gift-personalization-section-"]') || document.querySelector('.gp-modal-dialog');
    const backdrop = document.getElementById('gp-modal-backdrop');
    if (!section || !backdrop) return;

    const currency = section.dataset.currencySymbol || 'QAR';
    const isAr = section.dataset.lang === 'ar';

    const msgInput = section.querySelector('#gp-msg-text');
    const msgChars = section.querySelector('#gp-msg-chars');
    const engInput = section.querySelector('#gp-eng-text');
    const engChars = section.querySelector('#gp-eng-chars');
    const ribInput = section.querySelector('#gp-rib-text');
    const ribChars = section.querySelector('#gp-rib-chars');

    const engTypeInput = section.querySelector('#gp_eng_type');
    const engFontInput = section.querySelector('#gp_eng_font');
    const ribColorInput = section.querySelector('#gp_rib_color');
    const packStyleInput = section.querySelector('#gp_pack_style');

    const breakdownContainer = section.querySelector('#gp-breakdown-rows');
    const totalDisplay = section.querySelector('#gp-total-amount');
    const submitBtn = section.querySelector('#gp-continue-btn');
    const errorEl = section.querySelector('#gp-error-notice');
    const defaultBtnText = section.dataset.btnText || (isAr ? 'المتابعة مع هديتي ←' : 'CONTINUE WITH MY GIFT →');

    const photoInput = section.querySelector('#gp-photo-input');
    const photoDropzone = section.querySelector('#gp-photo-dropzone');
    const photoCard = section.querySelector('#gp-photo-selected-card');
    const photoName = section.querySelector('#gp-photo-name');
    const photoClearBtn = section.querySelector('#gp-photo-clear-btn');
    let uploadedFile = null;

    // 0.5 دمج حقل الكمية وزر Add to cart جنباً إلى جنب بنفس الارتفاع في قالب Prestige
    function alignQuantityAndBuyButtons() {
      const qtyBlock = document.querySelector('.product-info__block-item[data-block-type="quantity-selector"], .product-info__block-item[data-block-id="quantity_selector"]');
      const buyBlock = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"], .product-info__block-item[data-block-id="buy_buttons"]');
      
      if (!qtyBlock || !buyBlock) return;
      if (qtyBlock.parentNode && qtyBlock.parentNode.classList.contains('gp-quantity-buy-wrapper')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'gp-quantity-buy-wrapper';

      qtyBlock.parentNode.insertBefore(wrapper, qtyBlock);
      wrapper.appendChild(qtyBlock);
      wrapper.appendChild(buyBlock);
    }

    // 1. إدراج زر التخصيص في الترتيب المختار (فوق أو تحت أزرار الشراء)
    function injectButton() {
      const triggerWrap = document.getElementById('gp-page-trigger-container');
      if (!triggerWrap) return;

      const btnPosition = triggerWrap.dataset.position || section.dataset.btnPosition || 'above_cart';

      // الحاوية المستهدفة: الحاوية المدمجة (Quantity + Buy Buttons) أو بلوك أزرار الشراء الفعلي
      const targetBlock = document.querySelector('.gp-quantity-buy-wrapper') || document.querySelector(
        '.product-info__block-item[data-block-type="buy-buttons"], ' +
        '.product-info__block-item[data-block-id="buy_buttons"], ' +
        '.product-form__buy-buttons, ' +
        'buy-buttons'
      );

      if (targetBlock && targetBlock.parentNode) {
        if (btnPosition === 'below_cart') {
          if (targetBlock.nextSibling !== triggerWrap) {
            targetBlock.parentNode.insertBefore(triggerWrap, targetBlock.nextSibling);
          }
        } else {
          if (targetBlock.previousElementSibling !== triggerWrap) {
            targetBlock.parentNode.insertBefore(triggerWrap, targetBlock);
          }
        }
        return;
      }

      // الأولوية 2: بعد السعر إن لم تتوفر الأزرار
      const priceEl = document.querySelector('.product-info__block-item[data-block-type="price"], .product-info__block-item[data-block-id="price"]');
      if (priceEl && priceEl.parentNode) {
        if (priceEl.nextSibling !== triggerWrap) {
          priceEl.parentNode.insertBefore(triggerWrap, priceEl.nextSibling);
        }
        return;
      }

      // الأولوية 3: بعد العنوان
      const titleEl = document.querySelector('.product-info__block-item[data-block-type="title"], .product-info__block-item[data-block-id="title"], h1.product-title');
      if (titleEl && titleEl.parentNode) {
        if (titleEl.nextSibling !== triggerWrap) {
          titleEl.parentNode.insertBefore(triggerWrap, titleEl.nextSibling);
        }
        return;
      }
    }

    // 1.5 إدارة واختيار المتغيرات / المقاسات داخل المودال ومزامنتها
    function setupVariantSelector() {
      const variantChips = section.querySelectorAll('.gp-variant-chip-btn');
      if (!variantChips.length) return;

      variantChips.forEach(btn => {
        btn.addEventListener('click', () => {
          selectVariant(btn);
        });
      });

      window.gpSyncVariant = function(vId) {
        if (!vId) return;
        const targetBtn = section.querySelector(`.gp-variant-chip-btn[data-variant-id="${vId}"]`);
        if (targetBtn) {
          selectVariant(targetBtn, false);
        }
      };

      // استماع لتغييرات نموذج القالب على الصفحة
      const themeInputs = document.querySelectorAll('product-form form input[name="id"], [data-block-type="buy-buttons"] input[name="id"]');
      themeInputs.forEach(inp => {
        inp.addEventListener('change', () => {
          if (window.gpSyncVariant) window.gpSyncVariant(inp.value);
        });
      });

      document.addEventListener('variant:change', (e) => {
        const vId = e.detail?.variant?.id;
        if (vId && window.gpSyncVariant) window.gpSyncVariant(vId);
      });
    }

    function selectVariant(btn, updateTheme = true) {
      if (btn.classList.contains('disabled')) return;
      section.querySelectorAll('.gp-variant-chip-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const vId = btn.dataset.variantId;
      const vTitle = btn.dataset.variantTitle;
      const vPrice = parseFloat(btn.dataset.variantPrice);

      section.dataset.variantId = vId;
      if (!isNaN(vPrice) && vPrice > 0) {
        section.dataset.basePrice = vPrice;
      }

      const descStrong = section.querySelector('#gp-selected-variant-desc strong');
      if (descStrong) descStrong.textContent = vTitle;

      const headerPrice = section.querySelector('#gp-header-price');
      if (headerPrice && !isNaN(vPrice)) {
        headerPrice.textContent = `${vPrice.toFixed(2)} ${currency}`;
      }

      if (updateTheme) {
        const themeInputs = document.querySelectorAll('product-form form input[name="id"], input[name="id"][form*="product-form"]');
        themeInputs.forEach(inp => { inp.value = vId; });
      }

      if (btn.dataset.variantImg) {
        const heroImg = section.querySelector('#gp-main-hero-image');
        const productThumbBtn = section.querySelector('.gp-thumb-card-btn[data-target="product"]');
        if (heroImg) {
          heroImg.dataset.productImg = btn.dataset.variantImg;
          if (!productThumbBtn || productThumbBtn.classList.contains('active')) {
            heroImg.src = btn.dataset.variantImg;
          }
        }
        if (productThumbBtn) {
          productThumbBtn.dataset.bg = btn.dataset.variantImg;
        }
      }

      calculateTotals();
    }

    setupVariantSelector();

    alignQuantityAndBuyButtons();
    injectButton();
    [150, 450, 1000, 2000].forEach(delay => {
      setTimeout(() => {
        alignQuantityAndBuyButtons();
        injectButton();
      }, delay);
    });
    window.addEventListener('load', () => {
      alignQuantityAndBuyButtons();
      injectButton();
    });

    // 2. تفعيل التبديل للخيارات (Toggles)
    section.querySelectorAll('.gp-toggle-chk').forEach(chk => {
      chk.addEventListener('change', () => {
        const card = chk.closest('.gp-item-card');
        const body = card ? card.querySelector('.gp-item-card-body') : null;
        if (body) body.style.display = chk.checked ? 'block' : 'none';
        calculateTotals();
        updateLivePreview();
      });
    });

    // 3. أزرار مناسبات كرت الإهداء (Pill buttons)
    section.querySelectorAll('.gp-pill-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        section.querySelectorAll('.gp-pill-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const msg = btn.dataset.msg;
        if (msg !== undefined && msgInput) {
          msgInput.value = msg;
          if (msgChars) msgChars.textContent = msg.length;
          updateLivePreview();
        }
      });
    });

    if (msgInput) {
      msgInput.addEventListener('input', () => {
        if (msgChars) msgChars.textContent = msgInput.value.length;
        updateLivePreview();
      });
    }

    // 4. تبويبات الحفر والنقش
    section.querySelectorAll('.gp-tab-btn').forEach(tab => {
      tab.addEventListener('click', () => {
        section.querySelectorAll('.gp-tab-btn').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const type = tab.dataset.type;
        if (engTypeInput) engTypeInput.value = type;

        const textPanel = section.querySelector('#gp-eng-text-panel');
        const photoPanel = section.querySelector('#gp-eng-photo-panel');

        if (type === 'Photo') {
          if (textPanel) textPanel.style.display = 'none';
          if (photoPanel) photoPanel.style.display = 'block';
        } else {
          if (textPanel) textPanel.style.display = 'grid';
          if (photoPanel) photoPanel.style.display = 'none';
        }
        calculateTotals();
        updateLivePreview();
      });
    });

    // 5. خطوط الحفر
    section.querySelectorAll('.gp-font-item-box').forEach(box => {
      box.addEventListener('click', () => {
        section.querySelectorAll('.gp-font-item-box').forEach(b => b.classList.remove('active'));
        box.classList.add('active');
        if (engFontInput) engFontInput.value = box.dataset.font;
        updateLivePreview();
      });
    });

    if (engInput) {
      engInput.addEventListener('input', () => {
        if (engChars) engChars.textContent = engInput.value.length;
        updateLivePreview();
      });
    }

    // 6. رفع صورة الحفر
    if (photoDropzone && photoInput) {
      photoDropzone.addEventListener('click', () => photoInput.click());
      photoInput.addEventListener('change', (e) => {
        if (e.target.files && e.target.files[0]) {
          uploadedFile = e.target.files[0];
          if (photoName) photoName.textContent = uploadedFile.name;
          if (photoDropzone) photoDropzone.style.display = 'none';
          if (photoCard) photoCard.style.display = 'block';
          calculateTotals();
          updateLivePreview();
        }
      });
    }

    if (photoClearBtn) {
      photoClearBtn.addEventListener('click', () => {
        uploadedFile = null;
        if (photoInput) photoInput.value = '';
        if (photoDropzone) photoDropzone.style.display = 'flex';
        if (photoCard) photoCard.style.display = 'none';
        calculateTotals();
        updateLivePreview();
      });
    }

    // 7. ألوان الشريط
    section.querySelectorAll('.gp-swatch-dot').forEach(sw => {
      sw.addEventListener('click', () => {
        section.querySelectorAll('.gp-swatch-dot').forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
        if (ribColorInput) ribColorInput.value = sw.dataset.color;
      });
    });

    if (ribInput) {
      ribInput.addEventListener('input', () => {
        if (ribChars) ribChars.textContent = ribInput.value.length;
      });
    }

    // 8. المعاينة المباشرة الثابتة على صورة المنتج الفعلي مع النقش
    function switchPreviewTab(target) {
      section.querySelectorAll('.gp-thumb-card-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.target === target);
      });

      const heroImg = section.querySelector('#gp-main-hero-image');
      const engOverlay = section.querySelector('#gpLiveEngravingOverlay');

      // الحفاظ دائماً على صورة المنتج الأصلية والنقش المباشر عليها دون تبديل
      if (heroImg && heroImg.dataset.productImg) {
        heroImg.src = heroImg.dataset.productImg;
      }
      if (engOverlay) {
        engOverlay.style.display = 'block';
      }
    }

    // أزرار التنقل السفلية تحت المعاينة
    section.querySelectorAll('.gp-thumb-card-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.target;
        switchPreviewTab(target);

        let targetCard = null;
        if (target === 'product') targetCard = section.querySelector('[data-key="engraving"]') || section.querySelector('.gp-variant-selection-card');
        else if (target === 'card') targetCard = section.querySelector('[data-key="message"]');
        else if (target === 'ribbon') targetCard = section.querySelector('[data-key="ribbon"]');
        else if (target === 'box') targetCard = section.querySelector('[data-key="packaging"]');

        if (isWizard && targetCard) {
          const stepIdx = wizardSteps.indexOf(targetCard);
          if (stepIdx !== -1) {
            showStep(stepIdx, false);
          }
        } else if (targetCard) {
          targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          targetCard.style.transition = 'box-shadow 0.3s ease';
          targetCard.style.boxShadow = '0 0 0 2px var(--gp-gold)';
          setTimeout(() => { targetCard.style.boxShadow = ''; }, 1200);
        }
      });
    });

    // =========================================================================
    // نظام خطوات الـ Wizard (إذا كان مفعلاً من الداش بورد)
    // =========================================================================
    const isWizard = (section.dataset.wizard === 'true');
    const form = section.querySelector('#gift-personalization-form');
    let wizardSteps = form ? Array.from(form.querySelectorAll('.gp-item-card')) : [];
    let currentStep = 0;

    function showStep(index, syncThumb = true) {
      if (!isWizard || wizardSteps.length === 0) return;
      if (index < 0 || index >= wizardSteps.length) return;
      currentStep = index;

      wizardSteps.forEach((card, idx) => {
        if (idx === index) {
          card.style.display = 'block';
          card.classList.add('gp-wizard-step-active');
        } else {
          card.style.display = 'none';
          card.classList.remove('gp-wizard-step-active');
        }
      });

      const currentNumEl = section.querySelector('#gp-wizard-current-num');
      if (currentNumEl) currentNumEl.textContent = index + 1;

      const totalNumEl = section.querySelector('#gp-wizard-total-num');
      if (totalNumEl) totalNumEl.textContent = wizardSteps.length;

      const activeCard = wizardSteps[index];
      const stepTitle = activeCard.querySelector('.gp-item-card-title-row h4')?.textContent || 
                        activeCard.querySelector('h4')?.textContent || '';
      const titleEl = section.querySelector('#gp-wizard-current-title');
      if (titleEl) titleEl.textContent = stepTitle;

      const progressBar = section.querySelector('#gp-wizard-progress-bar');
      if (progressBar) {
        const pct = ((index + 1) / wizardSteps.length) * 100;
        progressBar.style.width = pct + '%';
      }

      const prevBtn = section.querySelector('#gp-wizard-prev-btn');
      const nextBtn = section.querySelector('#gp-wizard-next-btn');
      const continueBtn = section.querySelector('#gp-continue-btn');
      const quickFinish = section.querySelector('#gp-wizard-quick-finish');

      const isLast = (index === wizardSteps.length - 1);

      if (prevBtn) {
        prevBtn.style.setProperty('display', (index > 0) ? 'inline-flex' : 'none', 'important');
      }

      if (nextBtn) {
        nextBtn.style.setProperty('display', isLast ? 'none' : 'inline-flex', 'important');
        const nextCard = wizardSteps[index + 1];
        if (nextCard) {
          const nextKey = nextCard.dataset.key;
          let nextName = '';
          if (nextKey === 'message') nextName = isAr ? 'كرت الإهداء' : 'Message Card';
          else if (nextKey === 'ribbon') nextName = isAr ? 'شريط الإهداء' : 'Ribbon';
          else if (nextKey === 'packaging') nextName = isAr ? 'تغليف الهدايا' : 'Gift Box';
          else if (nextKey === 'engraving') nextName = isAr ? 'نقش الهدية' : 'Engraving';

          if (nextName) {
            nextBtn.innerHTML = isAr 
              ? `<span>الخطوة التالية (${nextName})</span> <span>←</span>` 
              : `<span>Next Step (${nextName})</span> <span>→</span>`;
          } else {
            nextBtn.innerHTML = isAr 
              ? `<span>الخطوة التالية</span> <span>←</span>` 
              : `<span>Next Step</span> <span>→</span>`;
          }
        }
      }

      if (continueBtn) {
        continueBtn.style.setProperty('display', isLast ? 'inline-flex' : 'none', 'important');
      }

      if (quickFinish) {
        quickFinish.style.setProperty('display', isLast ? 'none' : 'inline-block', 'important');
      }

      if (syncThumb) {
        const key = activeCard.dataset.key;
        let targetThumb = 'product';
        if (key === 'message') targetThumb = 'card';
        else if (key === 'engraving') targetThumb = 'product';
        else if (key === 'ribbon') targetThumb = 'ribbon';
        else if (key === 'packaging') targetThumb = 'box';

        switchPreviewTab(targetThumb);
      }
    }

    window.gpWizardNext = function() {
      if (currentStep < wizardSteps.length - 1) {
        showStep(currentStep + 1, true);
      }
    };

    window.gpWizardPrev = function() {
      if (currentStep > 0) {
        showStep(currentStep - 1, true);
      }
    };

    window.gpResetWizard = function() {
      if (isWizard) showStep(0, true);
    };

    if (isWizard) {
      showStep(0, true);
    } else {
      // إظهار جميع البطاقات دفعة واحدة عند إيقاف الـ Wizard
      wizardSteps.forEach(card => {
        card.style.display = 'block';
        card.classList.remove('gp-wizard-step-active');
      });
      const navWrapper = section.querySelector('#gp-wizard-nav-wrapper');
      if (navWrapper) navWrapper.style.setProperty('display', 'none', 'important');
      const prevBtn = section.querySelector('#gp-wizard-prev-btn');
      if (prevBtn) prevBtn.style.setProperty('display', 'none', 'important');
      const nextBtn = section.querySelector('#gp-wizard-next-btn');
      if (nextBtn) nextBtn.style.setProperty('display', 'none', 'important');
      const quickFinish = section.querySelector('#gp-wizard-quick-finish');
      if (quickFinish) quickFinish.style.setProperty('display', 'none', 'important');
      const continueBtn = section.querySelector('#gp-continue-btn');
      if (continueBtn) {
        continueBtn.style.setProperty('display', 'inline-flex', 'important');
      }
      const wizardHeader = section.querySelector('#gpWizardHeader, .gp-wizard-header');
      if (wizardHeader) wizardHeader.style.setProperty('display', 'none', 'important');
    }




    // 10. تفاعل الحفر المباشر: تحريك الكلمة داخل المربع الأحمر + تدوير وتكبير/تصغير من مقبض الزاوية
    function initEngravingControls() {
      const boundary = section.querySelector('#gpEngravingBoundary');
      const box = section.querySelector('#gpLiveEngravingBox');
      const handle = section.querySelector('#gpTransformHandle');
      const container = section.querySelector('#gpHeroImageContainer');

      if (!box || !boundary || !container) return;

      let isInteracting = false;
      let mode = null; // 'move' or 'transform'

      let startPointerX = 0;
      let startPointerY = 0;

      let currentRotation = 0;
      let currentScale = 1.0;
      let startRotation = 0;
      let startScale = 1.0;

      let startLeftPct = 50;
      let startTopPct = 50;

      let boxCenterX = 0;
      let boxCenterY = 0;
      let startAngleRad = 0;
      let startDistPx = 1;

      function updateTransform() {
        box.style.transform = `translate(-50%, -50%) rotate(${currentRotation.toFixed(1)}deg) scale(${currentScale.toFixed(2)})`;
        const rotInput = section.querySelector('#gp_eng_rot');
        const scaleInput = section.querySelector('#gp_eng_scale');
        if (rotInput) rotInput.value = Math.round(currentRotation);
        if (scaleInput) scaleInput.value = currentScale.toFixed(2);
      }

      function onStart(e) {
        const isHandle = e.target.closest('#gpTransformHandle');
        const isBox = e.target.closest('#gpLiveEngravingBox');
        if (!isBox && !isHandle) return;

        isInteracting = true;
        mode = isHandle ? 'transform' : 'move';

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        startPointerX = clientX;
        startPointerY = clientY;

        const bRect = box.getBoundingClientRect();
        boxCenterX = bRect.left + bRect.width / 2;
        boxCenterY = bRect.top + bRect.height / 2;

        if (mode === 'transform') {
          handle?.classList.add('is-active');
          box.classList.add('is-transforming');
          startRotation = currentRotation;
          startScale = currentScale;

          const dx = clientX - boxCenterX;
          const dy = clientY - boxCenterY;
          startAngleRad = Math.atan2(dy, dx);
          startDistPx = Math.hypot(dx, dy) || 1;
        } else {
          box.classList.add('is-moving');
          startLeftPct = parseFloat(box.style.left) || 50;
          startTopPct = parseFloat(box.style.top) || 50;
        }

        e.preventDefault();
        e.stopPropagation();
      }

      function onMove(e) {
        if (!isInteracting) return;

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        if (mode === 'transform') {
          const dx = clientX - boxCenterX;
          const dy = clientY - boxCenterY;

          // 1. حساب زاوية التدوير Rotate بالـ atan2
          const currAngleRad = Math.atan2(dy, dx);
          const deltaAngleDeg = (currAngleRad - startAngleRad) * (180 / Math.PI);
          currentRotation = (startRotation + deltaAngleDeg) % 360;

          // 2. حساب نسبة التكبير والتصغير Scale بالـ hypot
          const currDistPx = Math.hypot(dx, dy);
          const ratio = currDistPx / startDistPx;
          currentScale = Math.max(0.5, Math.min(2.5, startScale * ratio));

          updateTransform();
        } else if (mode === 'move') {
          const boundRect = boundary.getBoundingClientRect();
          if (boundRect.width === 0 || boundRect.height === 0) return;

          const deltaXPct = ((clientX - startPointerX) / boundRect.width) * 100;
          const deltaYPct = ((clientY - startPointerY) / boundRect.height) * 100;

          // تقييد الحركة داخل حدود المربع الأحمر
          const newLeft = Math.max(10, Math.min(90, startLeftPct + deltaXPct));
          const newTop = Math.max(10, Math.min(90, startTopPct + deltaYPct));

          box.style.left = `${newLeft.toFixed(1)}%`;
          box.style.top = `${newTop.toFixed(1)}%`;

          const posXInput = section.querySelector('#gp_eng_pos_x');
          const posYInput = section.querySelector('#gp_eng_pos_y');
          if (posXInput) posXInput.value = Math.round(newLeft);
          if (posYInput) posYInput.value = Math.round(newTop);
        }

        e.preventDefault();
      }

      function onEnd() {
        if (isInteracting) {
          isInteracting = false;
          box.classList.remove('is-moving', 'is-transforming');
          handle?.classList.remove('is-active');
          mode = null;
        }
      }

      box.addEventListener('mousedown', onStart);
      box.addEventListener('touchstart', onStart, { passive: false });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: false });

      window.addEventListener('mouseup', onEnd);
      window.addEventListener('touchend', onEnd);
    }

    initEngravingControls();

    // 11. أداة المعايرة البصرية لنسخ إحداثيات وزاوية أي منتج بنقرة واحدة (Admin Visual Box Drawer)
    function initAdminCalibrator() {
      const isDesignMode = (window.Shopify && window.Shopify.designMode) || 
                           window.location.search.includes('calibrator') || 
                           window.location.search.includes('admin') ||
                           window.location.search.includes('zone');
      const boundary = section.querySelector('#gpEngravingBoundary');
      const container = section.querySelector('#gpHeroImageContainer');
      const coordsEl = section.querySelector('#gpCalibratorCoords');
      const copyBtn = section.querySelector('#gpCalibratorCopyBtn');
      const bar = section.querySelector('#gpAdminCalibratorBar');
      const handles = section.querySelectorAll('.gp-calibrator-handle, .gp-calibrator-rotate-handle, .gp-calibrator-drag-badge');

      if (!boundary || !container) return;

      let currentZoneRot = 0;
      // استخراج زاوية الدوران المبدئية من نمط العنصر
      const currentTransform = boundary.style.transform || '';
      const rotMatch = currentTransform.match(/rotate\(([-0-9.]+)deg\)/);
      if (rotMatch) {
        currentZoneRot = Math.round(parseFloat(rotMatch[1])) || 0;
      }

      if (isDesignMode) {
        if (bar) bar.style.display = 'flex';
        handles.forEach(el => el.style.display = 'flex');
        boundary.style.pointerEvents = 'auto';
        boundary.style.cursor = 'move';
      }

      function updateCoordsText() {
        const cRect = container.getBoundingClientRect();
        const bRect = boundary.getBoundingClientRect();
        if (cRect.width === 0 || cRect.height === 0) return;

        let leftPct = parseFloat(boundary.style.left) || Math.round(((bRect.left - cRect.left + bRect.width / 2) / cRect.width) * 100);
        let topPct = parseFloat(boundary.style.top) || Math.round(((bRect.top - cRect.top + bRect.height / 2) / cRect.height) * 100);
        let widthPct = parseFloat(boundary.style.width) || Math.round((bRect.width / cRect.width) * 100);
        let heightPct = parseFloat(boundary.style.height) || Math.round((bRect.height / cRect.height) * 100);

        leftPct = Math.round(leftPct);
        topPct = Math.round(topPct);
        widthPct = Math.round(widthPct);
        heightPct = Math.round(heightPct);

        const valStr = `${topPct}, ${leftPct}, ${widthPct}, ${heightPct}, ${currentZoneRot}`;
        if (coordsEl) coordsEl.textContent = `${valStr}°`;
        window._currentZoneCoords = valStr;
      }

      window.gpCopyZoneCoords = function() {
        updateCoordsText();
        const textToCopy = window._currentZoneCoords || (coordsEl ? coordsEl.textContent.trim().replace('°', '') : '50, 50, 48, 22, 0');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(textToCopy).then(() => {
            if (copyBtn) {
              const orig = copyBtn.innerHTML;
              copyBtn.innerHTML = '✓ تم النسخ بنجاح!';
              copyBtn.style.background = '#15803d';
              copyBtn.style.color = '#ffffff';
              setTimeout(() => {
                copyBtn.innerHTML = orig;
                copyBtn.style.background = '';
                copyBtn.style.color = '';
              }, 2500);
            }
          }).catch(() => {
            prompt('انسخ إحداثيات وزاوية هذا المنتج:', textToCopy);
          });
        } else {
          prompt('انسخ إحداثيات وزاوية هذا المنتج:', textToCopy);
        }
      };

      if (!isDesignMode) return;

      let isDraggingBoundary = false;
      let isResizingBoundary = false;
      let isRotatingBoundary = false;
      let resizeDir = '';
      let startX = 0, startY = 0;
      let startLeft = 0, startTop = 0, startWidth = 0, startHeight = 0;

      function getPointerCoords(e) {
        if (e.touches && e.touches.length > 0) {
          return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        }
        return { x: e.clientX, y: e.clientY };
      }

      function startCalibratorDrag(e) {
        const rotateHandle = e.target.closest('.gp-calibrator-rotate-handle');
        const resizeHandle = e.target.closest('.gp-calibrator-handle');
        const cRect = container.getBoundingClientRect();
        const bRect = boundary.getBoundingClientRect();
        const pt = getPointerCoords(e);

        startX = pt.x;
        startY = pt.y;

        if (rotateHandle) {
          isRotatingBoundary = true;
          e.stopPropagation();
          if (e.cancelable) e.preventDefault();
        } else if (resizeHandle) {
          isResizingBoundary = true;
          resizeDir = resizeHandle.dataset.dir;
          startWidth = bRect.width;
          startHeight = bRect.height;
          startLeft = bRect.left - cRect.left;
          startTop = bRect.top - cRect.top;
          e.stopPropagation();
          if (e.cancelable) e.preventDefault();
        } else if (!e.target.closest('#gpLiveEngravingBox')) {
          isDraggingBoundary = true;
          startLeft = bRect.left - cRect.left + bRect.width / 2;
          startTop = bRect.top - cRect.top + bRect.height / 2;
          if (e.cancelable) e.preventDefault();
        }
      }

      function moveCalibratorDrag(e) {
        if (!isDraggingBoundary && !isResizingBoundary && !isRotatingBoundary) return;
        const cRect = container.getBoundingClientRect();
        if (cRect.width === 0 || cRect.height === 0) return;

        const pt = getPointerCoords(e);
        const dx = pt.x - startX;
        const dy = pt.y - startY;

        if (isRotatingBoundary) {
          const bRect = boundary.getBoundingClientRect();
          const centerX = bRect.left + bRect.width / 2;
          const centerY = bRect.top + bRect.height / 2;
          const rad = Math.atan2(pt.y - centerY, pt.x - centerX);
          let deg = Math.round((rad * 180 / Math.PI) + 90);
          while (deg > 180) deg -= 360;
          while (deg < -180) deg += 360;
          currentZoneRot = deg;
          boundary.style.transform = `translate(-50%, -50%) rotate(${currentZoneRot}deg)`;
          updateCoordsText();
        } else if (isDraggingBoundary) {
          const newLeftPct = Math.max(5, Math.min(95, ((startLeft + dx) / cRect.width) * 100));
          const newTopPct = Math.max(5, Math.min(95, ((startTop + dy) / cRect.height) * 100));

          boundary.style.left = `${newLeftPct.toFixed(1)}%`;
          boundary.style.top = `${newTopPct.toFixed(1)}%`;
          updateCoordsText();
        } else if (isResizingBoundary) {
          let newW = startWidth;
          let newH = startHeight;

          if (resizeDir.includes('e')) newW = startWidth + dx * 2;
          if (resizeDir.includes('w')) newW = startWidth - dx * 2;
          if (resizeDir.includes('s')) newH = startHeight + dy * 2;
          if (resizeDir.includes('n')) newH = startHeight - dy * 2;

          const newWPct = Math.max(5, Math.min(95, (newW / cRect.width) * 100));
          const newHPct = Math.max(5, Math.min(90, (newH / cRect.height) * 100));

          boundary.style.width = `${newWPct.toFixed(1)}%`;
          boundary.style.height = `${newHPct.toFixed(1)}%`;
          updateCoordsText();
        }
      }

      function endCalibratorDrag() {
        if (isDraggingBoundary || isResizingBoundary || isRotatingBoundary) {
          isDraggingBoundary = false;
          isResizingBoundary = false;
          isRotatingBoundary = false;
          updateCoordsText();
        }
      }

      boundary.addEventListener('mousedown', startCalibratorDrag);
      window.addEventListener('mousemove', moveCalibratorDrag);
      window.addEventListener('mouseup', endCalibratorDrag);

      boundary.addEventListener('touchstart', startCalibratorDrag, { passive: false });
      window.addEventListener('touchmove', moveCalibratorDrag, { passive: false });
      window.addEventListener('touchend', endCalibratorDrag);
    }

    initAdminCalibrator();


    // 9. حساب الإجمالي وتحديث جدول الأسعار
    function calculateTotals() {
      const base = parseFloat(section.dataset.basePrice) || 49.0;
      let addonTotal = 0;
      const rows = [];

      const title = section.querySelector('.gp-footer-prod-title')?.textContent || 
                    section.querySelector('.gp-product-header-meta h4')?.textContent || 'The Classic Oval Keychain';
      rows.push({ name: title, price: `${base.toFixed(2)} ${currency}` });

      const msgT = section.querySelector('input[name="enable_message"]');
      if (msgT && msgT.checked) {
        const p = parseFloat(msgT.closest('.gp-item-card')?.dataset.price) || 5.0;
        addonTotal += p;
        rows.push({ name: isAr ? 'بطاقة رسالة شخصية' : 'Personal Message (Card)', price: `+${p.toFixed(2)} ${currency}` });
      }

      const engT = section.querySelector('input[name="enable_engraving"]');
      if (engT && engT.checked) {
        const p = parseFloat(engT.closest('.gp-item-card')?.dataset.price) || 25.0;
        addonTotal += p;
        const type = engTypeInput?.value || 'Name';
        rows.push({ name: isAr ? `نقش مخصص (${type})` : `Custom Engraving (${type})`, price: `+${p.toFixed(2)} ${currency}` });
      }

      const ribT = section.querySelector('input[name="enable_ribbon"]');
      if (ribT && ribT.checked) {
        const p = parseFloat(ribT.closest('.gp-item-card')?.dataset.price) || 15.0;
        addonTotal += p;
        rows.push({ name: isAr ? 'شريط إهداء مخصص' : 'Personalized Ribbon', price: `+${p.toFixed(2)} ${currency}` });
      }

      const packT = section.querySelector('input[name="enable_packaging"]');
      if (packT && packT.checked) {
        const p = parseFloat(packT.closest('.gp-item-card')?.dataset.price) || 25.0;
        addonTotal += p;
        rows.push({ name: isAr ? 'تغليف هدايا فاخر' : 'Luxury Gift Packaging', price: `+${p.toFixed(2)} ${currency}` });
      }

      section.dataset.addonTotal = addonTotal;
      const total = base + addonTotal;

      if (totalDisplay) {
        totalDisplay.textContent = `${total.toFixed(2)} ${currency}`;
      }
    }

    window.gpRecalculate = function() {
      calculateTotals();
      updateLivePreview();
    };

    // 10. التحديث المباشر للمعاينة الحية (Live Dynamic Preview)
    function updateLivePreview() {
      const cardOverlay = section.querySelector('#gpLiveCardOverlay');
      const cardText = section.querySelector('#gpLiveCardText');
      const engOverlay = section.querySelector('#gpLiveEngravingOverlay');
      const engText = section.querySelector('#gpLiveEngravingText');
      const engPhoto = section.querySelector('#gpLiveEngravingPhoto');
      const engToolbar = section.querySelector('#gp-engraving-toolbar');

      // تحديث كرت الإهداء
      const msgToggle = section.querySelector('input[name="enable_message"]');
      if (msgToggle && !msgToggle.checked) {
        if (cardOverlay) cardOverlay.style.opacity = '0';
      } else {
        if (cardOverlay) cardOverlay.style.opacity = '1';
        const val = msgInput ? msgInput.value.trim() : '';
        const defMsg = isAr 
          ? 'عيد ميلاد سعيد!\nأتمنى لك عاماً رائعاً\nومليئاً بالسعادة ♥' 
          : 'Happy Birthday!\nWishing you a wonderful\nyear ahead ♥';
        
        if (cardText) {
          const textToDisplay = val || defMsg;
          cardText.textContent = textToDisplay;
          
          const isArabicText = /[\u0600-\u06FF]/.test(textToDisplay);
          if (isArabicText) {
            cardText.classList.add('is-arabic');
          } else {
            cardText.classList.remove('is-arabic');
          }

          const len = textToDisplay.length;
          if (len > 85) {
            cardText.style.fontSize = isArabicText ? '10px' : 'clamp(8px, 1.5vw, 11px)';
            cardText.style.lineHeight = '1.25';
          } else if (len > 45) {
            cardText.style.fontSize = isArabicText ? '12px' : 'clamp(9px, 1.8vw, 13px)';
            cardText.style.lineHeight = '1.3';
          } else {
            cardText.style.fontSize = isArabicText ? '13.5px' : 'clamp(10px, 2.1vw, 15px)';
            cardText.style.lineHeight = '1.35';
          }
        }
      }

      // تحديث النقش المباشر على صورة المنتج
      const engToggle = section.querySelector('input[name="enable_engraving"]');
      if (engToggle && !engToggle.checked) {
        if (engOverlay) engOverlay.style.opacity = '0';
        if (engToolbar) engToolbar.style.opacity = '0.5';
      } else {
        if (engOverlay) engOverlay.style.opacity = '1';
        if (engToolbar) engToolbar.style.opacity = '1';
        const type = engTypeInput ? engTypeInput.value : 'Name';
        
        if (type === 'Photo' && uploadedFile) {
          if (engText) engText.style.display = 'none';
          if (engPhoto) {
            engPhoto.style.display = 'block';
            if (!engPhoto.dataset.loadedFile || engPhoto.dataset.loadedFile !== uploadedFile.name) {
              const reader = new FileReader();
              reader.onload = (e) => {
                engPhoto.src = e.target.result;
                engPhoto.dataset.loadedFile = uploadedFile.name;
              };
              reader.readAsDataURL(uploadedFile);
            }
          }
        } else {
          if (engPhoto) engPhoto.style.display = 'none';
          if (engText) {
            engText.style.display = 'block';
            const val = engInput ? engInput.value.trim() : '';
            const defEng = isAr ? 'أحمد ♡' : 'Ahmed ♡';
            const textToEngrave = val ? (val.length <= 8 ? val + ' ♡' : val) : defEng;
            engText.textContent = textToEngrave;
            
            const isArabicEng = /[\u0600-\u06FF]/.test(textToEngrave);
            if (isArabicEng) {
              engText.classList.add('is-arabic');
            } else {
              engText.classList.remove('is-arabic');
            }

            const font = engFontInput ? engFontInput.value : 'Modern';
            if (font === 'Classic') {
              engText.style.fontFamily = isArabicEng ? "'Amiri', serif" : "'Playfair Display', serif";
              engText.style.fontStyle = isArabicEng ? 'normal' : 'italic';
            } else if (font === 'Handwritten') {
              engText.style.fontFamily = isArabicEng ? "'Amiri', cursive" : "'Great Vibes', cursive";
              engText.style.fontStyle = 'normal';
            } else {
              engText.style.fontFamily = isArabicEng ? "'Tajawal', sans-serif" : "'Montserrat', sans-serif";
              engText.style.fontStyle = 'normal';
            }
          }
        }
      }
    }



    // 11. معالجة الإضافة إلى السلة (Add to Cart AJAX)
    window.gpHandleAddToCart = async function() {
      if (errorEl) {
        errorEl.style.display = 'none';
        errorEl.textContent = '';
      }

      let variantId = section.dataset.variantId;
      const themeIdInput = document.querySelector('product-form form input[name="id"], [data-block-type="buy-buttons"] input[name="id"]');
      if (themeIdInput && themeIdInput.value) {
        variantId = themeIdInput.value;
      }

      const props = {};

      const activeChip = section.querySelector('.gp-variant-chip-btn.active');
      if (activeChip) {
        props[isAr ? 'المقاس / الخيار' : 'Selected Option'] = activeChip.dataset.variantTitle;
      }

      const msgT = section.querySelector('input[name="enable_message"]');
      if (msgT && msgT.checked) {
        const val = msgInput?.value.trim();
        if (!val) {
          showError(isAr ? 'يرجى كتابة نص رسالة الإهداء أو اختيار رسالة جاهزة.' : 'Please enter your message or select an occasion.');
          msgInput?.focus();
          return;
        }
        props['Personal Message'] = val;
      }

      const engT = section.querySelector('input[name="enable_engraving"]');
      let uploadFilePayload = null;
      if (engT && engT.checked) {
        const type = engTypeInput?.value || 'Name';
        if (type === 'Photo') {
          if (!uploadedFile) {
            showError(isAr ? 'يرجى اختيار صورة أو رسمة للحفر.' : 'Please upload a photo/design to engrave.');
            return;
          }
          props['Engraving Type'] = 'Custom Photo / Sketch';
          uploadFilePayload = uploadedFile;
        } else {
          const val = engInput?.value.trim();
          if (!val) {
            showError(isAr ? 'يرجى كتابة النص المراد حفره على الميدالية.' : 'Please enter the engraving text.');
            engInput?.focus();
            return;
          }
          const font = engFontInput?.value || 'Modern';
          const posX = section.querySelector('#gp_eng_pos_x')?.value || '50';
          const posY = section.querySelector('#gp_eng_pos_y')?.value || '50';
          const scale = section.querySelector('#gp_eng_scale')?.value || '1.0';
          const rot = section.querySelector('#gp_eng_rot')?.value || '0';
          props['Custom Engraving'] = `[${font} Font] ${val} (Position: X:${posX}%, Y:${posY}%, Scale:${scale}, Rotate:${rot}°)`;
        }
      }

      const ribT = section.querySelector('input[name="enable_ribbon"]');
      if (ribT && ribT.checked) {
        const val = ribInput?.value.trim();
        if (!val) {
          showError(isAr ? 'يرجى كتابة نص شريط الإهداء.' : 'Please enter ribbon text.');
          ribInput?.focus();
          return;
        }
        const col = ribColorInput?.value || 'Gold';
        props['Custom Ribbon'] = `[${col}] ${val}`;
      }

      const packT = section.querySelector('input[name="enable_packaging"]');
      if (packT && packT.checked) {
        props['Gift Packaging'] = isAr ? 'نعم (صندوق الهدايا الملكي الفاخر)' : 'Yes (Signature Luxury Gift Box)';
      }

      // حساب إجمالي الرسوم الإضافية
      const addonTotal = parseFloat(section.dataset.addonTotal) || 0;
      let addonProductId = parseInt(section.dataset.addonProductId, 10);
      const cartMode = section.dataset.cartMode || 'clear_all';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = isAr ? 'جاري الانتقال للشراء...' : 'REDIRECTING TO CHECKOUT...';
      }

      try {
        if (addonTotal > 0 && (!addonProductId || isNaN(addonProductId) || addonProductId <= 0)) {
          try {
            const autoRes = await fetch('/products/gift-personalization-fee.js');
            if (autoRes.ok) {
              const autoProd = await autoRes.json();
              if (autoProd && autoProd.variants && autoProd.variants.length > 0) {
                addonProductId = autoProd.variants[0].id;
                section.dataset.addonProductId = addonProductId;
              }
            }
          } catch (e) {
            console.warn('[GiftPersonalization] Auto fetch addon product failed:', e);
          }
        }

        if (addonTotal > 0 && (!addonProductId || isNaN(addonProductId) || addonProductId <= 0)) {
          console.error('[GiftPersonalization] Missing addon_fee_product!');
          showError(isAr 
            ? 'تنبيه: لم يتم العثور على منتج رسوم التخصيص. يرجى ربطه في إعدادات السكشن أو التأكد من نشر منتج Gift Personalization Fee بقيمة 1 ريال.' 
            : 'Notice: Please select the "Add-on Fee Product" in Section Settings.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultBtnText;
          }
          return;
        }

        // 1. تنظيف السلة لتفادي تكرار المنتجات والرسوم
        if (cartMode === 'clear_all') {
          await fetch('/cart/clear.js', { method: 'POST' });
        } else {
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          const cleanUpdates = {};
          let needsClean = false;

          cartData.items.forEach(item => {
            const iId = String(item.id || item.variant_id);
            const tId = String(variantId);
            const aId = String(addonProductId || '');

            if (iId === tId || (aId && iId === aId)) {
              cleanUpdates[item.key] = 0;
              needsClean = true;
            }
          });

          if (needsClean) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: cleanUpdates })
            });
          }
        }

        // 2. تجهيز العناصر للإضافة
        if (uploadFilePayload) {
          const formData = new FormData();
          formData.append('items[0][id]', variantId);
          formData.append('items[0][quantity]', '1');
          for (const [k, v] of Object.entries(props)) {
            formData.append(`items[0][properties][${k}]`, v);
          }
          formData.append('items[0][properties][رابط صورة الحفر / Engraving Photo]', uploadFilePayload, uploadFilePayload.name);

          if (addonTotal > 0 && addonProductId) {
            formData.append('items[1][id]', addonProductId);
            formData.append('items[1][quantity]', String(Math.max(1, Math.round(addonTotal))));
            formData.append('items[1][properties][_parent_id]', variantId);
            formData.append('items[1][properties][Service]', isAr ? 'رسوم تخصيص الهدية' : 'Gift Personalization Addon');
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            showError(err.description || err.message || (isAr ? 'تعذر إضافة التخصيص للسلة. يرجى التحقق من إعدادات المخزون.' : 'Failed to add gift to cart.'));
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = defaultBtnText;
            }
            return;
          }
        } else {
          const itemsToAdd = [
            {
              id: parseInt(variantId, 10),
              quantity: 1,
              properties: props
            }
          ];

          if (addonTotal > 0 && addonProductId) {
            itemsToAdd.push({
              id: parseInt(addonProductId, 10),
              quantity: Math.max(1, Math.round(addonTotal)),
              properties: {
                '_parent_id': String(variantId),
                'Service': isAr ? 'رسوم تخصيص الهدية' : 'Gift Personalization Addon'
              }
            });
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            showError(err.description || err.message || (isAr ? 'تعذر إضافة التخصيص للسلة. يرجى التحقق من إعدادات المخزون.' : 'Failed to add gift to cart.'));
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = defaultBtnText;
            }
            return;
          }
        }

        // 3. التوجيه للدفع
        window.location.href = '/checkout';

      } catch (e) {
        console.error('[GiftPersonalization] Error:', e);
        showError(isAr ? 'حدث خطأ في الاتصال بالمتجر، يرجى المحاولة ثانية.' : 'Network error. Please try again.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = defaultBtnText;
        }
      }
    };

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.style.display = 'block';
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    calculateTotals();
    updateLivePreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalization);
  } else {
    initPersonalization();
  }
  document.addEventListener('shopify:section:load', initPersonalization);
  document.addEventListener('shopify:block:select', initPersonalization);
  document.addEventListener('shopify:block:deselect', initPersonalization);
})();